module.exports = __webpack_public_path__ + "img/shangchuanwenjian.1fce696a.png";